import { DeviceStatusEnum } from 'modules/devices/constants';
import type { Hardware, StoredHardware } from 'modules/hardwares/types';

/**
 * Maps an API Hardware onto the stored shape: audit fields and the API `status` are
 * dropped, `status` is re-derived from `enabled` as a DeviceStatusEnum.
 */
export const hardwareCleaner = ({
  certificateExpiration,
  config,
  dealerId,
  enabled,
  hardwareId,
  name,
  lastSeen,
  tv,
}: Hardware): StoredHardware => ({
  certificateExpiration,
  config,
  dealerId,
  enabled,
  status: enabled ? DeviceStatusEnum.ACTIVE : DeviceStatusEnum.INACTIVE,
  hardwareId,
  name,
  lastSeen,
  tv,
});
